const en = {
    campus : "University Name",
    faculty: "Faculty",
    department: "Department",
    academicYear:"Academic Year",
    semester:"Semester",
    course:"Select Course",

    button: {
        setting:"Setting",
        create :"Create"
    },

    description : "Description",
    common: {
        loading: "Loading",
        lastUpdated: "Last updated",
        description: "Description",
        app: {
            dashboardSystem: "Dashboard System"
        },
        dialog: {
            error: "ERROR"
        },
        language: {
            badge: "Language: {lang}"
        },
        sections: {
            content: "Content",
            settings: "Settings"
        },
        actions: {
            add: "Add",
            apply: "Apply",
            cancel: "Cancel",
            edit: "Edit",
            exportCsv: "Export CSV",
            notNow: "Not now",
            open: "Open",
            remove: "Remove",
            save: "Save",
            update: "Update"
        },
        status: {
            label: "Status",
            active: "Active",
            inactive: "Inactive"
        },
        audit: {
            at: "AT",
            by: "BY",
            created: "Created",
            updated: "Updated"
        }
    },
    auth: {
        errors: {
            title: "Authentication Error"
        },
        signIn: {
            contactTitle: "1 Contact",
            contactText: "If you have trouble using this service, please contact the support team at One Stop Service, Academic Services Building (AS), 4th floor.",
            contactPhone: "Phone 0-5391-6411, 6053",
            socialTitle: "SIGN IN WITH SOCIAL",
            errors: {
                google: "Google Sign-In failed. Please try again."
            }
        },
        loginPage: {
            subtitle: "Sign in to your account",
            username: "Username",
            password: "Password",
            login: "Login",
            signUp: "Sign up",
            signUpText: "Create a new account to start using the platform services.",
            registerNow: "Register Now!"
        },
        twoFa: {
            title: "Authenticate Your Account",
            subtitle: "Protecting your account is our top priority.",
            instruction: "Please confirm your account by entering the authorization code sent to:",
            email: "E-mail",
            receiveHint: "It may take a minute to receive your code.",
            resendPrompt: "Haven't received it?",
            resendAction: "Resend a new code",
            errors: {
                resend: "Unable to resend verification code. Please try again.",
                verify: "Invalid or expired verification code. Please request a new code and try again."
            }
        },
        trustDevice: {
            title: "Trust This Device?",
            subtitle: "Reduce extra verification on this browser.",
            ifTrusted: "If trusted",
            ifTrustedText: "skip 2FA for the next 30 days.",
            condition: "Condition",
            conditionText: "same device and same network.",
            tip: "Tip",
            tipText: "use this only on your personal device.",
            confirm: "Trust this device"
        }
    },
    nav: {
        dashboard: "Dashboard",
        mcaRegistry: "MCA Registry",
        newSystemRegistry: "MCA Registry",
        businessOperations: "MCA Operations",
        banks: "Banks",
        template: "Template",
        accessControl: "Access Control",
        config: "Config",
        messageAuthen: "Message Authen",
        emailNotifications: "Email Notifications",
        workflowActions: "Workflow Actions",
        runtimeAccess: "Runtime Access",
        databaseBackup: "Database Backup",
        settingMessage: "Setting Message",
        settingVerification: "Setting Verification",
        setting: "Setting",
        settingGroup: "Setting Group",
        messageStatus: "Message Status",
        accounts: "Accounts",
        accountDirectory: "Account Directory",
        identityLifecycle: "Identity Lifecycle",
        training: "Training",
        trainingRequests: "Training Requests",
        trainingRecords: "Training Records",
        permission: "Permission",
        theme: "Theme",
        colors: "Colors",
        typography: "Typography",
        components: "Components",
        base: "Base",
        breadcrumbs: "Breadcrumbs",
        cards: "Cards",
        carousels: "Carousels",
        collapses: "Collapses",
        jumbotrons: "Jumbotrons",
        listGroups: "List Groups",
        navs: "Navs",
        navbars: "Navbars",
        paginations: "Paginations",
        popovers: "Popovers",
        progressBars: "Progress Bars",
        switches: "Switches",
        tabs: "Tabs",
        tooltips: "Tooltips",
        buttons: "Buttons",
        standardButtons: "Buttons",
        buttonDropdowns: "Button Dropdowns",
        buttonGroups: "Button Groups",
        brandButtons: "Brand Buttons",
        charts: "Charts",
        editors: "Editors",
        codeEditors: "Code Editors",
        textEditors: "Text Editors",
        forms: "Forms",
        basicForms: "Basic Forms",
        advancedForms: "Advanced Forms",
        validationForms: "Validation Forms",
        googleMaps: "Google Maps",
        icons: "Icons",
        coreUiIcons: "CoreUI Icons",
        brands: "Brands",
        flags: "Flags",
        notifications: "Notifications",
        alerts: "Alerts",
        badges: "Badges",
        modals: "Modals",
        toaster: "Toaster",
        plugins: "Plugins",
        draggable: "Draggable",
        calendar: "Calendar",
        spinners: "Spinners",
        tables: "Tables",
        basicTables: "Basic Tables",
        advancedTables: "Advanced Tables",
        widgets: "Widgets",
        extras: "Extras",
        pages: "Pages",
        login: "Login",
        register: "Register",
        error404: "Error 404",
        error500: "Error 500",
        apps: "Apps",
        invoicing: "Invoicing",
        invoice: "Invoice",
        email: "Email",
        inbox: "Inbox",
        message: "Message",
        compose: "Compose",
        labels: "Labels",
        labelDanger: "Label danger",
        labelInfo: "Label info",
        labelWarning: "Label warning",
        projectShortcuts: "Project shortcuts",
        projectSettings: "Settings",
        general: "General",
        new: "NEW",
        pro: "PRO"
    },
    newSystemDashboard: {
        kicker: "MCA Operations",
        title: "MCA management workspace",
        subtitle: "Manage agreements, partner ownership, review state, and renewal timing while access remains delegated through IAM.",
        scopeTitle: "Scope",
        scopeHeading: "Available modules",
        actions: {
            openRegistry: "Open MCA Registry"
        },
        scopeItems: {
            signIn: "Google sign-in for MCA users",
            delegatedPermission: "Permission management UI delegated to IAM",
            accountDirectory: "Account directory delegated from IAM",
            newSystemRegistry: "MCA registry, review, reporting, and renewal workflows"
        },
        cards: {
            identity: {
                label: "Identity Source",
                value: "IAM",
                hint: "MCA does not duplicate identity master data."
            },
            apiFlow: {
                label: "API Flow",
                value: "Client Credentials",
                hint: "Used for delegated MCA-to-IAM integration."
            },
            owner: {
                label: "Business Owner",
                value: "MCA",
                hint: "This system stores agreement and workflow data only."
            }
        }
    },
    accounts: {
        directory: {
            title: "Account Directory",
            subtitle: "Review account records and effective access from IAM without storing identity master data in MCA.",
            table: {
                subtitle: "Search and inspect account records delegated from IAM."
            },
            empty: {
                lastLogin: "Never"
            },
            actions: {
                edit: "Edit",
                access: "Access",
                remove: "Remove",
                invite: "Invite"
            },
            stats: {
                total: {
                    label: "Total Accounts",
                    hint: "Profiles returned from IAM"
                },
                active: {
                    label: "Active",
                    hint: "Ready for sign-in and access"
                },
                attention: {
                    label: "Attention Needed",
                    hint: "Pending, locked, or suspended"
                }
            },
            messages: {
                loadError: "Failed to load accounts.",
                loadSecurityWorkspaceError: "Cannot load account permission workspace.",
                updateSuccess: "Account access has been updated.",
                updateError: "Failed to update account access.",
                removeConfirmTitle: "Remove",
                removeConfirmMessage: "Remove {account} from MCA?",
                removeSuccess: "Account removed from MCA.",
                removeError: "Cannot remove account from MCA.",
                revokeSessionSuccess: "Session revoked.",
                revokeSessionError: "Cannot revoke session.",
                revokeTrustedDeviceSuccess: "Trusted device revoked.",
                revokeTrustedDeviceError: "Cannot revoke trusted device.",
                inviteTitle: "Invite to MCA",
                inviteSubtitle: "Invite an account and assign MCA access.",
                inviteSuccess: "Invitation completed.",
                inviteError: "Cannot invite account to MCA."
            },
            invite: {
                email: "Email",
                firstName: "First name",
                lastName: "Last name",
                groups: "MCA groups",
                groupPlaceholder: "Select one or more MCA groups",
                groupRequired: "Select at least one MCA group."
            }
        },
        permissions: {
            title: "Effective Permissions",
            subtitle: "Review assigned groups and the final permission matrix delegated from IAM.",
            summary: {
                assignedGroups: "Assigned Groups",
                permissionRows: "Permission Rows"
            },
            sections: {
                assignedGroups: "Assigned Groups",
                effectivePermissions: "Effective Permissions"
            },
            scope: "Scope",
            empty: {
                assignedGroups: "No assigned groups.",
                permissions: "No effective permissions found."
            }
        }
    },
    setting: {
        languages: {
            th: "Thai (th)",
            en: "English (en)"
        },
        emailNotifications: {
            title: "Email Notifications",
            subtitle: "Manage NewSystem workflow overrides delegated to IAM for identity emails such as account invitations, 2FA codes, and status notifications.",
            tableTitle: "Email Workflow Management",
            add: "Add Template",
            empty: "No email templates found",
            fields: {
                template: "Template",
                channel: "Channel",
                source: "Source",
                subject: "Subject",
                state: "State"
            },
            delivery: {
                title: "Delivery Settings",
                appName: "Application name",
                appUrl: "Application URL",
                fromName: "Sender name",
                from: "Sender email",
                replyTo: "Reply-to email",
                smtp: "SMTP",
                host: "Host",
                port: "Port",
                user: "Username",
                password: "Password",
                passwordConfigured: "Password (configured)",
                passwordHint: "Leave blank to keep current password",
                secure: "Use secure SMTP (TLS/465)",
                save: "Save Delivery"
            },
            templates: {
                invite: "Invite Email",
                inviteChannel: "Account invitation",
                twoFa: "2FA Email",
                twoFaChannel: "Sign-in verification",
                locked: "Account Locked Email",
                lockedChannel: "Account lock notification",
                unlocked: "Account Unlocked Email",
                unlockedChannel: "Account access restored notification",
                activated: "Account Activated Email",
                activatedChannel: "Account activation notification",
                deactivated: "Account Deactivated Email",
                deactivatedChannel: "Account deactivation notification",
                suspended: "Account Suspended Email",
                suspendedChannel: "Account suspension notification",
                archived: "Account Archived Email",
                archivedChannel: "Account archive notification",
                statusChanged: "Status Changed Email",
                statusChangedChannel: "Generic account status change notification",
                accessChanged: "Access Changed Email",
                accessChangedChannel: "Security group access change notification",
                provisioned: "Provisioned Email",
                provisionedChannel: "Account provisioning notification",
                deprovisioned: "Deprovisioned Email",
                deprovisionedChannel: "Account deprovisioning notification",
                sessionsCleared: "All Sessions Cleared Email",
                sessionsClearedChannel: "All-session sign-out notification",
                trustedDeviceAdded: "Trusted Device Email",
                trustedDeviceAddedChannel: "Trusted device confirmation",
                sessionRevoked: "Session Revoked Email",
                sessionRevokedChannel: "Session revocation notification",
                trustedDeviceRevoked: "Trusted Device Revoked Email",
                trustedDeviceRevokedChannel: "Trusted device revocation notification"
            },
            form: {
                createTitle: "Add Email Template",
                editTitle: "Edit Email Template",
                editHint: "Update email subject, text body, and HTML body for this notification.",
                preview: "Preview",
                htmlPreview: "HTML Preview",
                fields: {
                    eventKey: "Event key",
                    templateName: "Template name",
                    description: "Description",
                    placeholders: "Custom placeholders",
                    text: "Text body",
                    html: "HTML body"
                },
                validation: {
                    subject: "Please provide email subject.",
                    customTemplate: "Please provide event key, template name, and email subject."
                }
            },
            placeholders: {
                title: "Template Placeholders",
                appId: "Application scope",
                appName: "Application name",
                appUrl: "Application URL",
                email: "Recipient email",
                firstName: "Recipient first name",
                lastName: "Recipient last name",
                fullName: "Recipient full name",
                code: "2FA verification code",
                expiresMinutes: "2FA expiry minutes",
                invited: "Invite flow flag",
                fromStatus: "Previous account status",
                toStatus: "New account status",
                statusTitle: "Current status title",
                statusDescription: "Current status description",
                groupCount: "Assigned group count",
                currentGroups: "Current security groups",
                addedGroups: "Added security groups",
                removedGroups: "Removed security groups",
                changedBy: "Changed by",
                targetStatus: "Target account status",
                provisioningState: "Provisioning state",
                provisioningStrategy: "Provisioning strategy",
                recommendedProfiles: "Recommended access profiles",
                matchedRuleCount: "Matched lifecycle rule count",
                warningCount: "Lifecycle warning count",
                deprovisionReason: "Deprovision reason",
                revokeSessions: "Revoke active sessions",
                clearTrustedDevices: "Clear trusted devices",
                triggeredBy: "Triggered by",
                sessionCount: "Cleared session count",
                deviceIds: "Signed-out device identifiers",
                currentSessionIncluded: "Included current session",
                clearedBy: "Cleared by",
                sessionId: "Session identifier",
                deviceId: "Device identifier",
                clientId: "OAuth client identifier",
                audience: "Audience scope",
                system: "Application system",
                userAgent: "Device user agent",
                lastIp: "Last known IP address",
                trustedAt: "Trusted at timestamp",
                expiresAt: "Expiry timestamp",
                revokedBy: "Revoked by"
            },
            sources: {
                default: "System Default",
                override: "Workflow Override",
                inherited: "Inherited"
            },
            messages: {
                loadError: "Cannot load email notification settings.",
                saved: "Email notification settings saved.",
                saveError: "Cannot save email notification settings.",
                workflowSaved: "Email workflow override saved.",
                workflowSaveError: "Cannot save email workflow override.",
                workflowRemoved: "Email workflow override removed.",
                workflowRemoveError: "Cannot remove email workflow override.",
                removeConfirmTitle: "Remove Override",
                removeConfirmMessage: "Remove workflow override for {template}?"
            }
        },
        workflowActions: {
            title: "Workflow Actions",
            subtitle: "Configure NewSystem email workflow action behavior delegated to IAM, including recipient routing, enablement, and optional runtime conditions.",
            eventsTitle: "Workflow Events",
            emptySelection: "Select workflow event",
            fields: {
                actionType: "Action type",
                actionEnabled: "Enable this action",
                recipientMode: "Recipient mode",
                recipientValue: "Recipient value",
                conditionField: "Condition field",
                templateSubject: "Template subject"
            },
            actionTypes: {
                email: "Send email"
            },
            recipientModes: {
                request: "Request recipient",
                context: "Context field",
                literal: "Fixed email"
            },
            placeholders: {
                contextRecipient: "email",
                literalRecipient: "ops@example.com",
                conditionField: "invited"
            },
            actions: {
                save: "Save Action"
            },
            messages: {
                loadError: "Cannot load workflow actions.",
                saved: "Workflow action saved.",
                saveError: "Cannot save workflow action."
            }
        },
        runtimeAccess: {
            title: "Runtime Access",
            subtitle: "Manage browser origins, socket origins, trusted proxy handling, rate limiting, and IP allow lists without redeploying the service.",
            cardTitle: "Runtime Access Controls",
            sourceLabel: "Current source",
            defaultsTitle: "Environment fallback",
            fields: {
                trustProxy: "Trust reverse proxy headers",
                rateLimitEnabled: "Enable rate limit and temporary IP blocking",
                corsAllowedOrigins: "Browser CORS allowed origins",
                socketCorsOrigins: "Socket.IO allowed origins",
                allowedIPs: "Allowed client IPs"
            },
            hints: {
                trustProxy: "Use X-Forwarded-* headers when NewSystem runs behind reverse proxies or ingress layers.",
                rateLimitEnabled: "When disabled, temporary IP blocking and request throttling are skipped.",
                corsAllowedOrigins: "One origin per line. Exact match only, for example https://new-system.mfu.ac.th",
                socketCorsOrigins: "One origin per line. Keep these aligned with browser origins for stable websocket upgrades.",
                allowedIPs: "One IP per line. Leave empty to allow all IPs after authentication and CORS checks."
            },
            placeholders: {
                origins: "https://new-system.mfu.ac.th\nhttps://iam.mfu.ac.th",
                ips: "192.168.10.10\n10.20.30.40"
            },
            sources: {
                database: "Database",
                environment: "Environment fallback"
            },
            monitoring: {
                blockedTitle: "Active blocked IPs",
                blockedSubtitle: "IP addresses currently blocked by runtime rate limiting.",
                eventsTitle: "Recent runtime events",
                eventsSubtitle: "Recent deny and block decisions captured by runtime access controls.",
                eventsHint: "Only recent deny and block decisions are kept here. This feed resets whenever the backend restarts.",
                emptyBlocked: "No IPs are currently blocked.",
                emptyEvents: "No runtime access events captured yet.",
                fields: {
                    occurredAt: "Occurred at",
                    ip: "IP",
                    source: "Source",
                    reason: "Reason",
                    blockedAt: "Blocked at",
                    expiresAt: "Expires at",
                    remaining: "Remaining",
                    target: "Request",
                    type: "Type",
                    decision: "Decision",
                    statusCode: "Status",
                    message: "Message",
                    detail: "Detail",
                    actions: "Actions"
                },
                remainingExpired: "Expired",
                remainingMinutes: "{minutes}m",
                remainingMinutesSeconds: "{minutes}m {seconds}s",
                remainingSeconds: "{seconds}s"
            },
            actions: {
                useFallback: "Use fallback values",
                unblock: "Unblock"
            },
            messages: {
                loadError: "Unable to load runtime access settings.",
                saved: "Runtime access settings saved.",
                permissionDenied: "You do not have permission to update runtime access settings.",
                saveError: "Unable to save runtime access settings.",
                defaultsApplied: "Fallback values copied into the form.",
                unblocked: "Blocked IP removed.",
                unblockError: "Unable to unblock this IP."
            }
        },
        databaseBackup: {
            title: "Database Backup",
            subtitle: "Manage NewSystem database backups from CMS, including auto backup scheduling, manual runs, retention, downloads, and cleanup.",
            cardTitle: "Backup Settings",
            previewTitle: "Preview Collections",
            previewEmpty: "Click Preview Collections to inspect which collections will be included.",
            previewNotLoaded: "Preview not loaded",
            previewLoaded: "Previewed at {time}, {documents} documents",
            historyTitle: "Backup History",
            historyPreviewTitle: "Backup File Preview",
            historyPreviewEmpty: "Preview a backup from history to inspect its collections.",
            historyPreviewLoaded: "{name}, created {createdAt}, {documents} documents",
            activeBadge: "Backup running",
            fields: {
                autoEnabled: "Auto backup",
                enabled: "Enabled",
                disabled: "Disabled",
                intervalHours: "Interval hours",
                retentionCount: "Auto retention count",
                backupDir: "Backup directory",
                collectionName: "Collection",
                type: "Type",
                mode: "Mode",
                status: "Status",
                databaseName: "Database",
                startedAt: "Started",
                completedAt: "Completed",
                sizeBytes: "Size",
                collections: "Collections",
                documentCount: "Documents",
                checksum: "SHA-256",
                actions: "Actions"
            },
            modes: {
                auto: "Auto",
                manual: "Manual"
            },
            statuses: {
                completed: "Completed",
                running: "Running",
                failed: "Failed"
            },
            actions: {
                previewCollections: "Preview Collections",
                saveSettings: "Save Settings",
                runNow: "Run Backup",
                previewBackup: "Preview",
                restore: "Restore",
                download: "Download",
                delete: "Delete"
            },
            messages: {
                loadError: "Unable to load database backup settings.",
                saved: "Database backup settings saved.",
                saveError: "Unable to save database backup settings.",
                manualStarted: "Manual database backup completed.",
                manualError: "Unable to run database backup.",
                previewError: "Unable to preview database collections.",
                previewBackupError: "Unable to preview this backup.",
                restored: "Database restore completed.",
                restoreError: "Unable to restore this backup.",
                restoreConfirmTitle: "Restore Backup",
                restoreConfirmMessage: "Restore backup {name}? Current collection data will be replaced.",
                deleted: "Backup deleted.",
                deleteError: "Unable to delete backup.",
                downloadError: "Unable to download backup.",
                permissionDenied: "You do not have permission to manage database backups.",
                deleteConfirmTitle: "Delete Backup",
                deleteConfirmMessage: "Delete backup {name}?"
            }
        },
        status: {
            title: "Setting Status",
            subtitle: "Manage status keys, labels, descriptions, and active state for shared master data.",
            tableTitle: "Status Management",
            add: "Add Status",
            empty: "No status found",
            editTitle: "Edit Status",
            createTitle: "Create Status",
            fields: {
                group: "Group",
                key: "Key",
                title: "Title",
                description: "Description",
                titleTh: "Title (TH)",
                titleEn: "Title (EN)",
                descriptionTh: "Description (TH)",
                descriptionEn: "Description (EN)",
                state: "State"
            },
            form: {
                editHint: "Update status that supports multiple languages.",
                createHint: "Configure status that supports multiple languages.",
                fields: {
                    title: "Title",
                    group: "Group",
                    key: "Key",
                    state: "State"
                },
                validation: {
                    required: "Please fill all required fields.",
                    title: "Please provide at least one language title.",
                    group: "Please select group.",
                    key: "Please provide status key."
                }
            },
            messages: {
                loadError: "Failed to load status list.",
                loadSelectedError: "Cannot load selected status.",
                updated: "Status updated.",
                created: "Status created successfully.",
                saveError: "Cannot save status.",
                removeTitle: "Remove Status",
                removeConfirm: "Are you sure you want to remove this status?",
                removed: "Status removed.",
                removeError: "Cannot remove status."
            }
        }
    },
    security: {
        messages: {
            loadError: "Failed to load security data."
        },
        createMenu: {
            title: "Create Menu",
            subtitle: "Manage menu types, register navigable paths, and keep the permission catalog aligned.",
            editMenu: "Edit Menu",
            addType: "Add Type",
            editType: "Edit Type",
            menusTitle: "Menus",
            typesTitle: "Type Management",
            addMenu: "Add Menu",
            emptyMenus: "No menus found",
            emptyTypes: "No types found",
            fields: {
                menuTitle: "Menu Title",
                path: "Path",
                type: "Type",
                typeTitle: "Type Title"
            },
            stats: {
                types: "Types",
                menus: "Menus",
                mapped: "Mapped"
            },
            messages: {
                typeUpdated: "Type updated.",
                typeCreated: "Type created successfully.",
                cannotSaveType: "Cannot save type.",
                typeRemoved: "Type removed.",
                typeInUse: "Cannot remove type in use.",
                mappedReadonly: "Mapped menu cannot be edited.",
                menuUpdated: "Menu updated.",
                menuCreated: "Menu created successfully.",
                cannotSaveMenu: "Cannot save menu.",
                mappedRemove: "Mapped menu cannot be removed.",
                menuRemoved: "Menu removed.",
                cannotRemoveMenu: "Cannot remove menu."
            }
        },
        createGroup: {
            title: "Create Group",
            subtitle: "Define access groups, shape visibility by type, and keep assignment structure readable.",
            editGroup: "Edit Group",
            tableTitle: "Groups",
            addGroup: "Add Group",
            empty: "No groups found",
            fields: {
                groupTitle: "Group Title",
                visibleType: "Visible Type"
            },
            stats: {
                groups: "Groups",
                visibleTypes: "Visible Types",
                readyToAssign: "Ready to Assign"
            },
            messages: {
                groupUpdated: "Group updated.",
                groupCreated: "Group created successfully.",
                cannotSave: "Cannot save group.",
                groupRemoved: "Group removed.",
                cannotRemove: "Cannot remove group."
            }
        },
        permissionManagement: {
            title: "Permission Management",
            subtitle: "Move through the setup flow in order to define menus, create groups, and control the final permission matrix.",
            recommendedFlow: "Recommended Flow",
            stats: {
                step1: "Step 1",
                step2: "Step 2",
                step3: "Step 3",
                menu: "Menu",
                group: "Group",
                matrix: "Matrix"
            },
            steps: {
                menu: {
                    eyebrow: "Foundation",
                    title: "Create Menu",
                    description: "Register menu entries, map paths, and prepare the permission catalog."
                },
                group: {
                    eyebrow: "Grouping",
                    title: "Create Group",
                    description: "Build access groups and define which menu types each group can see."
                },
                matrix: {
                    eyebrow: "Control",
                    title: "Permission Matrix",
                    description: "Apply the final permission rules that determine what each group can do."
                }
            },
            guide: {
                menuLabel: "1. Create Menu",
                menuText: "Register menu types and paths first so the permission matrix has a stable target list.",
                groupLabel: "2. Create Group",
                groupText: "Define access groups and their visible type boundaries before assigning rules.",
                matrixLabel: "3. Permission Matrix",
                matrixText: "Grant view, edit, delete, action, and logs access once menus and groups are ready."
            }
        },
        auditExplorer: {
            title: "Audit Explorer",
            subtitle: "Review authentication, account, and lifecycle events recorded by the IAM platform.",
            eventsLoaded: "Events loaded",
            exportFile: "iam-audit-events.csv",
            filters: {
                module: "Module",
                action: "Action",
                actorId: "Actor ID",
                resourceId: "Resource ID"
            },
            fields: {
                timestamp: "Timestamp",
                module: "Module",
                action: "Action",
                actor: "Actor",
                resource: "Resource",
                ip: "IP",
                detail: "Detail"
            },
            stats: {
                events: "Events",
                auth: "Auth",
                accounts: "Accounts"
            },
            messages: {
                loadError: "Cannot load audit events."
            }
        },
        formModal: {
            group: {
                editHint: "Update an access group and its visible type boundary.",
                createHint: "Create an access group for permission assignment.",
                validationTitle: "Please enter group name.",
                validationVisibleType: "Please select visible type."
            },
            menu: {
                editHint: "Update a menu entry used in the permission catalog.",
                createHint: "Create a menu entry and map it to a security type.",
                validationTitle: "Please enter menu name.",
                validationPath: "Path must start with /.",
                validationType: "Please select type."
            },
            type: {
                editHint: "Update type that supports multiple languages.",
                createHint: "Configure type that supports multiple languages.",
                validationTitle: "Please enter type title."
            }
        },
        permissionMatrix: {
            title: "Permission Matrix",
            subtitle: "Review group-to-menu rules, tune access switches, and keep the permission grid controlled.",
            lastUpdated: "Last updated",
            selectedGroup: "Selected Group",
            menus: "Menus",
            visibleRules: "Visible Rules",
            allTypes: "All Types",
            tableTitle: "Permission Table",
            fields: {
                menu: "Menu",
                type: "Type",
                path: "Path",
                source: "Source",
                all: "All",
                view: "View",
                edit: "Edit",
                delete: "Delete",
                action: "Action",
                owner: "Owner",
                logs: "Logs"
            },
            messages: {
                loadError: "Failed to load security data.",
                saveError: "Failed to save permissions."
            }
        }
    }
}

en.nav = Object.assign({}, en.nav || {}, {
    projectOperations: 'Application Workspace'
})

export default en
